import React, { PropTypes } from "react";

export default function VariationView({ children }) {
    return (<fieldset className="border-top no-padding-bottom">{children}</fieldset>);
}

VariationView.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Views/VariationView.jsx